import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import buildVersion from '../../../assets/build-version.json';
import { environment } from '../../../environments/environment';
import { WizardComponent } from '../wizard/wizard.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [WizardComponent],
})
export class AppComponent {
    public constructor() {
        const translate = inject(TranslateService);

        console.debug(`Initializing User Portal Web client v${buildVersion.buildVersion}...`);
        void translate.use(environment.defaultLocale);
    }
}
